import React from 'react'
import { Label } from 'reactstrap'
import { Icon } from 'components/icons'
import { FILTER_TYPES } from 'store/modules/common/filters'
import { NumericFilter } from './numericFilter'
import { DateFilter } from './dateFilter'
import { StringFilter } from './stringFilter'
import { EnumFilter } from './enumFilter'
import { LookupFilter } from './lookupFilter'

const Column = ({ column, localize, update, classes, availableColumns }) => {
  switch(column.type) {
    case FILTER_TYPES.numeric: return <NumericFilter column={column} classes={classes} localize={localize} update={update} />
    case FILTER_TYPES.date: return <DateFilter column={column} classes={classes} localize={localize} update={update} />
    case FILTER_TYPES.string: return <StringFilter column={column} classes={classes} localize={localize} update={update} />
    case FILTER_TYPES.enum: return <EnumFilter column={column} classes={classes} localize={localize} update={update} availableColumns={availableColumns} />
    case FILTER_TYPES.lookup: return <LookupFilter column={column} classes={classes} localize={localize} update={update} availableColumns={availableColumns} />

    default: return <div>Unkown filter column type: {column.type}</div>
  }
}

export const FilterItem = ({ column, index, localize, classes, onRemove, update, availableColumns }) => {
  const handleRemove = React.useCallback(() => onRemove(index), [onRemove, index])
  const handleUpdate = React.useCallback((delta) => update({ index, ...delta }), [update, index])
  return (
    <div className={classes.column}>
      <div className={classes.header}>
        <Label>{localize(`filters.column_${column.id}`)}</Label>
        <div className={classes.trash} onClick={handleRemove}>
          <Icon name='times' />
        </div>
      </div>
      <div className={classes.body}>
        <Column column={column} localize={localize} update={handleUpdate} classes={classes} availableColumns={availableColumns} />
      </div>
    </div>
  )
}